export enum ElectricityMeterType {
    Single = 'single',
    Double = 'double',
    Digital = 'digital',
    Unknown = 'unknown',
}
